import cc from 'classcat'
import React from 'react'

import { reactClass } from '../../utils'
import * as Styled from './styles'

export type ModalBodyProps = {
  children?: React.ReactNode
  className?: string
}

export const ModalBody = ({ children, className }: ModalBodyProps) => (
  <Styled.ModalBodyWrapper className={cc([className, reactClass('modal-body')])}>{children}</Styled.ModalBodyWrapper>
)
